var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.509 15.186c1.572.163 3.145.327 5.079.22 5.239-.293 8.413-2.985 8.187-7.01-.23-4.094-4.452-6.617-8.677-6.38C14.214 2.398 9.15 8.45 8.58 15.367c.936-.22 1.92-.35 2.848-.403 1.935-.107 3.508.057 5.08.22zm-13.5 8.95c.218 3.754 4.219 6.066 8.221 5.85 6.524-.352 11.322-5.9 11.862-12.24-.886.201-1.819.321-2.698.369-1.832.099-3.323-.051-4.813-.202-1.49-.15-2.98-.3-4.812-.201-4.964.268-7.97 2.736-7.757 6.425z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnt);
export default __webpack_public_path__ + "static/media/SNT.9a974d9c9fe552db4c84c5a3ea119343.svg";
export { ForwardRef as ReactComponent };